<template>
  <div>
    <div class="d-flex flex-column align-content-around">
      <div v-if="!!linked" v-sticky>
        <mdb-view :gradient="gradient" rounded class="mb-4 pt-2">
          <h5>
            Created order will be linked to {{ type }} order {{ description }}.
            <mdb-btn
              icon="times"
              size="sm"
              gradient="sunny-morning"
              rounded
              @click="setLinked(null)"
              class="my-0 ml-5"
            />
          </h5>
        </mdb-view>
      </div>
      <calc-controls/>
      <calc-flights/>
      <calc-rates/>
    </div>
  </div>
</template>

<script>
import CalcControls from './CalcControls'
import CalcRates from './CalcRates'
import CalcFlights from './CalcFlights'
import { mapActions, mapState } from 'vuex'
import {errorCatch} from '../utils'
import { Sticky, mdbView, mdbBtn } from 'mdbvue'
import {OrderTypes} from '../enums'

export default {
  name: 'Calc',
  methods: {
    ...mapActions('calc', ['fetch', 'setLinked', 'setData']),
    ...mapActions([
      'apiFetchLocations',
      'apiFetchAirlines',
      'apiFetchClientNames',
      'apiFetchAgentNames',
      'apiFetchMeasureUnitNames',
      'apiFetchMeasureUnitsInfo',
      'apiFetchCurrencyNames'
    ])
  },
  computed: {
    ...mapState('calc', {
      linked: state => state.linked
    }),
    type: function () {
      return this.linked.client ? OrderTypes.CLIENT : OrderTypes.AGENT
    },
    gradient: function () {
      switch (this.type) {
        case OrderTypes.CLIENT: return 'aqua'
        case OrderTypes.AGENT: return 'deep-blue'
      }
    },
    description: function () {
      return this.linked.info.name ? `"${this.linked.info.name}"` : `#${this.linked.info.number}`
    }
  },
  created () {
    this.apiFetchLocations().then(data => this.setData({entity: 'locations', data: data}))
      .catch(errorCatch('Fetch Locations Failed failed', this))
    this.apiFetchAirlines().then(data => this.setData({entity: 'airlines', data: data}))
      .catch(errorCatch('Fetch Airlines Failed failed', this))
    this.apiFetchClientNames().then(data => this.setData({entity: 'clients', data: data}))
      .catch(errorCatch('Fetch Clients failed', this))
    this.apiFetchAgentNames().then(data => this.setData({entity: 'agents', data: data}))
      .catch(errorCatch('Fetch Agents failed', this))
    this.apiFetchCurrencyNames().then(data => this.setData({entity: 'currencies', data: data}))
      .catch(errorCatch('Fetch Currencies failed', this))
    this.apiFetchMeasureUnitsInfo().then(data => this.setData({entity: 'measureUnitsInfo', data: data}))
      .catch(errorCatch('Fetch Currencies failed', this))
  },
  components: {
    CalcRates,
    CalcFlights,
    CalcControls,
    mdbView,
    mdbBtn
  },
  directives: {
    sticky: Sticky
  }
}
</script>

<style lang="sass">
.vld-overlay
  opacity: 0.7
</style>



// WEBPACK FOOTER //
// src/components/Calc.vue